// extracted by mini-css-extract-plugin
export var projectStyle = "{mdx-slug}-module--project-style--2ZktD";
export var listItem = "{mdx-slug}-module--list-item--ODicq";